

























































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import EventCreationForm from "@/components/EventCreationForm.vue";
import { VibrixEvent } from "@/interfaces/vibrixEvent";
import { EventService } from "@/services/eventService";
import EventDetailCard from "@/components/EventDetailCard.vue";
import { DataTableHeader } from "vuetify";
import { DateService } from "@/services/dateService";
import { ReportService } from "@/services/reportService";
import EventCreateCalendar from "@/components/customActions/EventCreateCalendar.vue";
import { authGuard } from "@/auth/authGuard";

@Component({
    components: {
        EventCreationForm,
        EventDetailCard,
        EventCreateCalendar,
    },
    beforeRouteEnter: authGuard,
})
export default class EventManager extends Vue {
    public showCreateEvent: boolean = false;

    public events: VibrixEvent[] = [];
    public get calendarEvents() {
        return this.events.map(e => ({
            ...e,
            start_time: DateService.formatDateForVCalendar(
                new Date(e.start_time)
            ),
            end_time: DateService.formatDateForVCalendar(new Date(e.end_time)),
        }));
    }

    public loading: boolean = false;
    public deletingInProgress: boolean = false;
    public navigator = navigator;

    public token: string = "";
    public calendarType: "month" | "day" = "month";

    public selectedMonth = new Date().toISOString().substring(0, 7);
    public selectedDay = new Date().toISOString().substring(7, 2);

    public selectedEvent: null | VibrixEvent = null;
    public eventDetailDialog: boolean = false;
    public persistDialog: boolean = false;
    public linkCreateDialog: boolean = false;

    $refs: {
        calendar: Vue & { title: string; prev: () => void; next: () => void };
    } = this.$refs;

    public get selectedMonthDay() {
        return `${this.selectedMonth}-${this.selectedDay}`;
    }

    public set selectedMonthDay(v: string) {
        this.selectedMonth = v.substr(0, 7);
        this.selectedDay = v.substr(8, 2);
    }

    public onClickMore(e: { date: string }) {
        this.selectedMonthDay = e.date;
        this.calendarType = "day";
    }

    public onClickEvent(e: { event: VibrixEvent }) {
        this.selectedEvent = e.event;
        this.eventDetailDialog = true;
    }

    public onEventCreated(event: VibrixEvent) {
        this.showCreateEvent = false;
        this.events.push(event);
    }

    public onEventUpdated(event: VibrixEvent) {
        const prevEvent = this.events.find(e => e.id === event.id);
        if (prevEvent) {
            Object.assign(prevEvent, event);
            Object.assign(this.selectedEvent, event);
        }
        this.$store.commit("showSnackbar", {
            text: this.$t("event.updated"),
            color: "success",
        });
        this.persistDialog = false;
    }

    public async onEventDeleted(eventId: string) {
        const deletedEvent = this.events.findIndex(e => e.id === eventId);
        if (deletedEvent >= 0) {
            this.deletingInProgress = true;
            await EventService.deleteEvent(eventId, this.token);
            this.events.splice(deletedEvent, 1);
            this.$store.commit("showSnackbar", {
                text: this.$t("event.deleted"),
                color: "success",
            });
            this.deletingInProgress = false;

            this.eventDetailDialog = false;
            this.persistDialog = false;
        }
    }

    public async createReport(id: string) {
        try {
            const report = await ReportService.eventReport(id, this.token);
            this.$store.commit("showSnackbar", {
                color: "success",
                text: this.$t("event.report"),
            });
            const filelink = ReportService.downloadJSON(
                JSON.stringify(report.data, undefined, 4),
                "report"
            );
            filelink.click();
        } catch (error) {
            this.$store.commit("showSnackbar", {
                color: "error",
                text: error.response.data,
            });
        }
    }

    public formatIsoString(string: string) {
        return DateService.formatIsoString(string, this.$i18n.locale);
    }
    public get eventHeaders(): DataTableHeader[] {
        return [
            {
                text: "Title",
                value: "title",
            },
            {
                text: "Start Date/Time",
                value: "start_time",
            },
            {
                text: "End Date/Time",
                value: "end_time",
            },
            {
                text: this.$t("event.actions").toString(),
                value: "actions",
            },
        ];
    }

    public async mounted() {
        if (!this.$auth.loading) {
            if (this.$auth.isAuthenticated) {
                this.token = await this.$auth.getTokenSilently();
            }
        } else {
            this.$auth.$watch("loading", async loading => {
                if (!loading) {
                    if (this.$auth.isAuthenticated) {
                        this.token = await this.$auth.getTokenSilently();
                    }
                }
            });
        }
    }

    @Watch("token")
    public async loadEvents() {
        this.loading = true;
        try {
            this.events = await EventService.getAllEvents(this.token);
        } finally {
            this.loading = false;
        }
    }
    public determineEventColor(e: VibrixEvent) {
        if (e.isFull) return "error";
        return e.is_private ? "secondary lighten-4" : "primary";
    }
}
